module.exports = __webpack_public_path__ + "static/img/d3showreel.94241936.jpg";